import { useState, useCallback } from 'react';

// « Série » : le quiz avance TOUJOURS par petites séries (une dizaine de questions,
// moins si le vivier est plus petit). Chaque série a une FIN (écran de bilan) qui
// donne un objectif court terme et un moment de closure, puis on enchaîne sur une
// nouvelle série. Pas d'objectif quotidien, pas de backlog affiché.
// Compteurs en mémoire : un rechargement repart simplement sur une série fraîche.
// `depart` reprend l'avancement d'une séance restaurée : sans lui, aller
// consulter une fiche du dictionnaire au milieu d'une série la faisait
// recommencer à zéro au retour.
export default function useDailyGoal(depart = {}) {
  const [done, setDone] = useState(depart.done ?? 0);
  const [rescued, setRescued] = useState(depart.rescued ?? 0);

  const bump = useCallback(() => setDone((d) => d + 1), []);
  const rescue = useCallback(() => setRescued((r) => r + 1), []);
  // Fin de série (ou changement de filtre) → on repart à zéro pour la série suivante.
  const dismiss = useCallback(() => { setDone(0); setRescued(0); }, []);

  return { done, rescued, bump, rescue, dismiss };
}
